import { TFunction } from 'react-i18next';
import moment from 'moment-timezone';

export const dateFormat = 'HH:mm Do MMM YY';

export const getFormattedTimeRange = (
  start: number,
  end: number,
  timezone: string,
  t: TFunction<'campaigns'>,
): string => {
  if (!start && !end) {
    return t('campaigns:alwaysRunning');
  }
  if (start && end) {
    return t('campaigns:runningFromTo', {
      start: formattedTime(start, timezone) || t('campaigns:notSet'),
      end: formattedTime(end, timezone) || t('campaigns:notSet'),
    });
  }
  if (start && !end) {
    return t('campaigns:runningFrom', {
      start: formattedTime(start, timezone) || t('campaigns:notSet'),
    });
  }
  if (!start && end) {
    return t('campaigns:runningTo', {
      end: formattedTime(end, timezone) || t('campaigns:notSet'),
    });
  }
};

const formattedTime = (time: number, timezone: string): string | undefined => {
  if (time) {
    return moment(time)
      .tz(timezone)
      .format(dateFormat);
  } else {
    return undefined;
  }
};
